import {
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { forwardRef, useImperativeHandle, useState } from "react";
import CancelIcon from "../../assets/icons/cross-bold-icon.png";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = null;
const ViewNoteDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <Stack
        p={1}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          variant="h1"
          fontSize={"1.5rem"}
          fontWeight={500}
          color={"secondary.dark"}
        >
          Note
        </Typography>
        <IconButton onClick={handleClose}>
          <img src={CancelIcon} alt="cancel-icon" width={25} />
        </IconButton>
      </Stack>
      <DialogContent dividers>
        <Typography>{paramsData?.data}</Typography>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default ViewNoteDialog;
